var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import "../../../const/iconLibrary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack } from "syf-component-library/ui/spacing";
import { useStatementsContext } from "../../../context/statementsContext";
import MessageBox from "../MessageBox";
import { ManageProfileButton } from "./subcomponents";
import { getClickAnalyticsProperties } from "../../../const/analytics";
var MissingEmailMessage = function () {
    var t = useTranslation().t;
    var _a = useStatementsContext(), accountId = _a.state.accountId, handleProfileClick = _a.handleProfileClick;
    var handleManageProfileClick = function () {
        handleProfileClick(accountId);
    };
    return (_jsxs(_Fragment, { children: [_jsx(MessageBox, __assign({ type: "error", icon: _jsx(FontAwesomeIcon, { icon: faExclamationTriangle, size: "lg" }), description: "missingEmail.body", title: "missingEmail.title", color: "#fcf4f3", titleStackSize: "xsmall", shouldUseLargeMobileTopMargin: true, removeHorizontalMargin: true }, { children: _jsx(ManageProfileButton, __assign({ buttonType: "text" }, getClickAnalyticsProperties({ reason: "manage profile" }), { onClick: handleManageProfileClick }, { children: t("missingEmail.manageProfile") })) })), _jsx(Stack, { size: "xsmall" })] }));
};
export default MissingEmailMessage;
